import { ITags } from 'source/NFR.types';

const Tags: React.FC<ITags> = ({ list }) => {
  return (
    <div className="tags">
      {list?.map(tag => (
        <div className="tags-item" key={tag}>
          {tag}
        </div>
      ))}
    </div>
  );
};

Tags.displayName = 'Tags';

export default Tags;
